import { styled } from '@mui/material';

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-top: 22px;
  width: 100%;
`;

export const Action = styled('div')`
  display: inline-flex;
  flex-direction: column;
  gap: 22px;
  margin: 16px 0 0 0;
  align-items: center;
  justify-content: center;
  & > * {
    width: 100%;
  }
`;
